const BASE_PATH = '/periodic-review';

export const PERIODIC_REVIEW_PATHS = {
  AML_QUESTIONNAIRE: `${BASE_PATH}/aml-questionnaire`,
  BASE: BASE_PATH,
  COMPLETE: `${BASE_PATH}/complete`,
  FCA_QUESTIONNAIRE: `${BASE_PATH}/fca-questionnaire`,
  FCA_QUESTIONNAIRE_INELIGIBLE: `${BASE_PATH}/fca-questionnaire/ineligible`,
  FORBIDDEN_JURISDICTION: `${BASE_PATH}/personal-information/forbidden-jurisdiction`,
  NATIONAL_CLIENT_IDENTIFIER: `${BASE_PATH}/national-client-identifier`,
  PERSONAL_INFORMATION: `${BASE_PATH}/personal-information`,
  SUMMARY: `${BASE_PATH}/summary`,
  VERIFICATION: `${BASE_PATH}/verification`,
};
